import { dataSourceItem } from "../redux/models/reduxModels";
import { NewDocumentTemplate } from "../interfaces/IDocumentTemplate";
import { DatasourceTypeEnum } from "../components/enums/datasourceTypeEnum";
import { DocubirdCache } from "../config/constants";
import { CacheHelper } from "../../../utilities/CacheHelper";
import { getSharepointLibraryFiles } from "./SharePointRestServices";
import { logger } from "../../../utilities/logger";

/**
 * Loads every SharePointDocumentTemplate datasource's library files into the datasource
 * template cache. Extracted from ContentManager/contentManagerTeams so the custom-fields
 * scan command can refresh the cache too. Returns true when the cache was (re)written -
 * callers dispatch signalCacheUpdate() themselves (the service stays store-free).
 */
export const refreshDatasourceDocumentTemplates = async (datasources: dataSourceItem[]): Promise<boolean> => {
  try {
    const dsDocTemplates: NewDocumentTemplate[] = [];

    if (Array.isArray(datasources) && datasources.length > 0) {
      await Promise.all(datasources
        .filter(ds => ds.type.id === DatasourceTypeEnum.SharePointDocumentTemplate)
        .map(async ds => {
          try {
            const templateDocuments = await getSharepointLibraryFiles(ds.url, ds.name, Array.isArray(ds.boundFields) && ds.boundFields.length > 0 ? ds.boundFields[0].name : null);
            if (templateDocuments?.length > 0) {
              dsDocTemplates.push(...templateDocuments
                .filter(template => template)
                .map(template => ({ ...template, datasource: ds }))
              );
            }
          } catch (error) {
            logger(error, "DatasourceTemplateService.ts (refreshDatasourceDocumentTemplates)");
          }
        }));
    }

    if (dsDocTemplates.length > 0) {
      CacheHelper.set(DocubirdCache.datasourceDocumentTemplates, dsDocTemplates.sort((a, b) => a.title?.toUpperCase() < b.title?.toUpperCase() ? -1 : 1));
      return true;
    }
  } catch (error) {
    // Ignore - matches the previous inline behaviour
  }
  return false;
};
